import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ToastProvider } from './hooks/useToast'
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import MobileNav from './components/layout/MobileNav'
import QuickActionsFab from './components/layout/QuickActionsFab'
import ScrollToTop from './components/layout/ScrollToTop'
import ToastContainer from './components/ui/ToastContainer'
import HomePage from './pages/HomePage'
import CalendarPage from './pages/CalendarPage'
import ArtistsPage from './pages/ArtistsPage'
import MarketplacePage from './pages/MarketplacePage'
import ForumsPage from './pages/ForumsPage'
import EventPage from './pages/EventPage'
import ProfilePage from './pages/ProfilePage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import SubmitEventPage from './pages/SubmitEventPage'
import AdvertisePage from './pages/AdvertisePage'
import HelpPage from './pages/HelpPage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import ContentPolicyPage from './pages/ContentPolicyPage'
import LinksHubPage from './pages/LinksHubPage'
import ReviewsPage from './pages/ReviewsPage'
import ReviewDetailPage from './pages/ReviewDetailPage'
import ThreadPage from './pages/ThreadPage'
import CreateListingPage from './pages/CreateListingPage'
import AdminImportPage from './pages/AdminImportPage'
import NotFoundPage from './pages/NotFoundPage'
import AboutWichita from './pages/AboutWichita'
import AboutLittleEddie from './pages/AboutLittleEddie'
import PartnersPage from './pages/PartnersPage'

function App() {
  return (
    <ToastProvider>
      <Router>
        <div className="min-h-screen bg-le-bg">
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/artists" element={<ArtistsPage />} />
              <Route path="/marketplace" element={<MarketplacePage />} />
              <Route path="/forums" element={<ForumsPage />} />
              <Route path="/events/:id" element={<EventPage />} />
              <Route path="/profile/:id" element={<ProfilePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/submit-event" element={<SubmitEventPage />} />
              <Route path="/advertise" element={<AdvertisePage />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/content-policy" element={<ContentPolicyPage />} />
              <Route path="/links" element={<LinksHubPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/reviews/:id" element={<ReviewDetailPage />} />
              <Route path="/thread/:id" element={<ThreadPage />} />
              <Route path="/marketplace/new" element={<CreateListingPage />} />
              <Route path="/admin/import" element={<AdminImportPage />} />
              <Route path="/about-wichita" element={<AboutWichita />} />
              <Route path="/about-little-eddie" element={<AboutLittleEddie />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Footer />
          <MobileNav />
          <QuickActionsFab />
          <ToastContainer />
        </div>
      </Router>
    </ToastProvider>
  )
}

export default App